/**
Project: Voice Panel (c)
Title: Boundary Error  
Description: Error Page to be displayed during the component errors
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { Image, Flex, Text, Button } from "@fluentui/react-northstar";
import SippioVoicePanelLogo from "../../../assets/images/SIPPIO-VoicePanel-Logo.png";
import IntlUtil from "../helpers/intl-util";
import TelemetryUtil from "../helpers/telemetry-util";
import { AppURLProps } from "../settings/app-urls";
import { AppPageTitle } from "../components/app-page-title";

class ErrorBoundary extends Component {
  _intl_ns_common = "common";

  state = {
    errorMessage: "",
  };
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  componentDidUpdate() {
    window.scrollTo(0, 0);
  }

  static getDerivedStateFromError(error) {
    return { errorMessage: error.toString() };
  }
  componentDidCatch(error, info) {
    TelemetryUtil.logException(error, info);
  }

  render() {
    if (this.state.errorMessage) {
      return (
        <>
          <AppPageTitle pageTitle={IntlUtil.getText(this._intl_ns_common, "title.clientError")} />
          <div id="error-page">
            <header className="error-page-header">
              <Image
                src={SippioVoicePanelLogo}
                alt={IntlUtil.getText(
                  this._intl_ns_common,
                  "content.voicePanelBySippio"
                )}
                title={IntlUtil.getText(
                  this._intl_ns_common,
                  "content.voicePanelBySippio"
                )}
              />
            </header>
            <div className="error-page-content">
              <Flex column className="error-page-segment">
                <Flex className="m-b-20">
                  <Text error size="large" className="text-bold text-uppercase">
                    Error
                  </Text>
                </Flex>
                <Flex className="m-b-30">
                  <Text size="medium">{this.state.errorMessage}</Text>
                </Flex>
                {window.location.pathname !== AppURLProps.signin ? (
                  <Flex gap="gap.medium" className="m-b-20">
                    <Button
                      size="medium"
                      onClick={() => document.location.href = AppURLProps.home}
                      content="Go to Home Page"
                    >
                    </Button>
                    <Button
                      size="medium"
                      onClick={() => document.location.href = AppURLProps.signin}
                      content="Go to Sign in Page"
                    >
                    </Button>
                  </Flex>
                ) : null}
              </Flex>
            </div>
          </div >
        </>
      );
    } else {
      return this.props.children;
    }
  }
}

export default ErrorBoundary;
